import classNames from "classnames";
import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Schedule from "src/components/icons/Schedule";
import { VehicleState } from "Types/state";
import ScheduleAppointment from "../ScheduleAppointment";
import StepCard from "../StepCard";
// import TradeIn from "../TradeIn";
// import UploadYourDocuments from "../UploadYourDocuments";
import "./StepThree.scss";

export interface StepThreeProps {
    active?: boolean;
    className?: string;
    hasAppointment: boolean;
    vehicle: VehicleState;
    stepName?: string;
    title?: string;
    text_active?: string;
    text_inactive?: string;
}

interface Dictionary<T> {
    [Key: string]: T;
}

interface StepThreeState {
    editTradeIn: boolean;
    optForAppointment: boolean;
    uploadYourDocumentsModalOpen: boolean;
    uploadedDocuments: Dictionary<File | null>;
}

class StepThree extends Component<StepThreeProps & WithTranslation, StepThreeState> {
    constructor(props: StepThreeProps & WithTranslation) {
        super(props);

        this.state = {
            editTradeIn: false,
            optForAppointment: props.hasAppointment,
            uploadYourDocumentsModalOpen: false,
            uploadedDocuments: {},
        };
    }
    public render() {
        const { active, className, hasAppointment, stepName, t } = this.props;

        return (
            <StepCard
                active={active}
                className={classNames("StepThree", className)}
                done={hasAppointment}
                icon={Schedule}
            >
                <span className="StepThree__step-name">
                    {stepName ? stepName : t("ContinueDeal.StepThree.stepName")}
                </span>
                {this.renderContent()}
            </StepCard>
        );
    }
    private renderContent = () => {
        const { active, hasAppointment, title } = this.props;

        return (
            <div>
                {!hasAppointment && (
                    <>
                        <p className="StepThree__title">{title}</p>
                        {this.renderText()}
                    </>
                )}

                {(active || hasAppointment) && (
                    <div className="StepThree__content">
                        {/* <TradeIn
                        setOptForAppointment={this.setOptForAppointment}
                        optForAppointment={this.state.optForAppointment}
                        setEditTradeIn={this.setEditTradeIn}
                        editTradeIn={this.state.editTradeIn}
                    /> */}
                        {/* <UploadYourDocuments
                            onDocumentUpdated={this.handleDocumentUpdated}
                            uploadedDocuments={this.state.uploadedDocuments}
                            setOptForAppointment={this.setOptForAppointment}
                            optForAppointment={this.state.optForAppointment}
                            toggleUploadYourDocuments={
                                this.toggleUploadYourDocumentsModal
                            }
                            uploadYourDocumentsModalOpen={
                                this.state.uploadYourDocumentsModalOpen
                            }
                            vehicle={this.props.vehicle}
                        /> */}
                        <ScheduleAppointment />
                    </div>
                )}
            </div>
        );
    };

    private renderText = () => {
        const { active, text_active, text_inactive } = this.props;

        return <p className="StepThree__text">{active ? text_active : text_inactive}</p>;
    };

    // private handleDocumentUpdated = (id: string, file: File | null) => {
    //     this.setState({
    //         uploadedDocuments: { ...this.state.uploadedDocuments, [id]: file }
    //     });
    // };

    // private setOptForAppointment = (optFor: boolean) => {
    //     this.setState({
    //         optForAppointment: optFor
    //     });
    // };

    /* private setEditTradeIn = (editTradeIn: boolean) => {
        this.setState({
            editTradeIn
        });
    }; */

    // private toggleUploadYourDocumentsModal = (
    //     uploadYourDocumentsModalOpen: boolean
    // ) => {
    //     this.setState({
    //         uploadYourDocumentsModalOpen
    //     });
    // };
}

export default withTranslation()(StepThree);
